module.exports = __webpack_public_path__ + "static/media/advantages_bar_middle_top.f46be48a.svg";